/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Scan_BarcodeInputs */

const vi_pos_scan_barcode = /** @type {(inputs: Pos_Scan_BarcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã vạch`)
};

/**

* @param {Pos_Scan_BarcodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_scan_barcode = /** @type {((inputs?: Pos_Scan_BarcodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Scan_BarcodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_scan_barcode(inputs)
});